const assign = require( 'object-assign' );

const withDefaultAlias = values => assign(
    {},
    values,
    values.default ? {DEFAULT: values.default} : {}
);
/*

Tailwind - The Utility-First CSS Framework

A project by Adam Wathan (@adamwathan), Jonathan Reinink (@reinink),
David Hemphill (@davidhemphill) and Steve Schoger (@steveschoger).

Welcome to the Tailwind config file. This is where you can customize
Tailwind specifically for your project. Don't be intimidated by the
length of this file. It's really just a big JavaScript object and
we've done our very best to explain each section.

View the full documentation at https://tailwindcss.com.


|-------------------------------------------------------------------------------
| The default config
|-------------------------------------------------------------------------------
|
| This variable contains the default Tailwind config. You don't have
| to use it, but it can sometimes be helpful to have available. For
| example, you may choose to merge your custom configuration
| values with some of the Tailwind defaults.
|
*/

// let defaultConfig = require( 'tailwindcss/defaultConfig' )();

/*
|-------------------------------------------------------------------------------
| Colors                                    https://tailwindcss.com/docs/colors
|-------------------------------------------------------------------------------
|
| Here you can specify the colors used in your project. To get you started,
| we've provided a generous palette of great looking colors that are perfect
| for prototyping, but don't hesitate to change them for your project. You
| own these colors, nothing will break if you change everything about them.
|
| We've used literal color names ("red", "blue", etc.) for the default
| palette, but if you'd rather use functional names like "primary" and
| "secondary", or even a numeric scale like "100" and "200", go for it.
|
*/

/*
 #d9d9d6, #d0d0ce, #c8c9c7, #bbbcbc
Use for light neutral colors on the site
Ultradent Medium Grays

Medium Neutral Colors
RGB colors: #b1b3b3, #a7a8aa, #97999b
Use for medium neutral colors on the site

Ultradent Dark Grays
Dark Neutral Colors
RGB colors: #888b8d, #75787b, #63666a, #53565a
 */

let colors = {
    'transparent': 'transparent',

    'black': '#000000',
    'near-black': '#202020',
    'grey-darkest': '#53565a',
    'grey-darker': '#63666a',
    'grey-dark': '#75787b',
    'grey': '#a7a8aa',
    'grey-medium': '#A7A8AA',
    'grey-light': '#b1b3b3',
    'grey-lighter': '#c8c9c7',
    'grey-lightest': '#e8e8e8',
    'moon-grey': '#f0f0f0',
    'near-white': '#f8f8f8',
    'white': '#ffffff',

    // branding
    // 'brand': '#e35205', // Original brand color, not WCAG compliant
    'brand': '#de3700', // WCAG compliant
    'bronze': '#aa662c',
    'silver': '#6e7781',
    'gold': '#8a6a2f',
    'platinum': '#696765',

    // ui colors
    'warning': '#ff9900',
    'sky-blue': '#009cde',
    'success': '#64a70b',
    'fail': '#e10600',
    'stable': '#009cde',
    'fail-lighter': 'rgba(225,6,0,0.09)',
    'fail-lightest': 'rgba(225,6,0,0.06)',
    'tooth-whitening': '#62b5e5',
    'prevent-hygiene': '#6fa287',
    'prepare': '#7e5475',
    'triodent': '#9fc35c',
    'bond-etch': '#5f8fb4',
    'tips-syringes': '#63666a',
    'endodontics': '#115e67',
    'equipment': '#333f48',
    'tissue-management': '#be3a34',
    'composites': '#c6893f',
    'impressions': '#702f8a',
    'finish': '#cb6015',
    'crown-bridge': '#eed484',
    'surgical': '#9c182f',
    'direct-restorative': '#f3dd5b',
    'indirect-restorative': '#f4bd2d',
    'complete-solutions': '#b34998',

    'opal-brand-home': '#77c19a',
    'opal-brand-home-500': '#3b815c',
    'opal-brand-home-light': '#dff1e8',
    'opal-brand-custom': '#9f8fca',
    'opal-brand-custom-500': '#665b95',
    'opal-brand-custom-light': '#e6e3f0',
    'opal-brand-pro': '#e57200',
    'opal-brand-pro-500': '#c75300',
    'opal-brand-pro-light': '#fee6cf',
    // legacy colors
    'opal-brand-pf': '#7fade3',
    'opal-brand-pf-500': '#3d77bd',
    'opal-brand-pf-light': '#e3eef6',

    'valo-brand-blue': '#00a9ce',
    'valo-brand-blue-dark': '#0075ba',

    // tailwind original

    // 'red-darkest': '#3b0d0c',
    // 'red-darker': '#621b18',
    // 'red-dark': '#cc1f1a',
    // 'red': '#e3342f',
    // 'red-light': '#ef5753',
    // 'red-lighter': '#f9acaa',
    // 'red-lightest': '#fcebea',
    //
    // 'orange-darkest': '#462a16',
    // 'orange-darker': '#613b1f',
    // 'orange-dark': '#de751f',
    // 'orange': '#f6993f',
    // 'orange-light': '#faad63',
    // 'orange-lighter': '#fcd9b6',
    // 'orange-lightest': '#fff5eb',
    //
    // 'yellow-darkest': '#453411',
    // 'yellow-darker': '#684f1d',
    // 'yellow-dark': '#f2d024',
    // 'yellow': '#ffed4a',
    'yellow-lighter': '#fff9c2'
    //
    // 'green-darkest': '#0f2f21',
    // 'green-darker': '#1a4731',
    // 'green-dark': '#1f9d55',
    // 'green': '#38c172',
    // 'green-light': '#51d88a',
    // 'green-lighter': '#a2f5bf',
    // 'green-lightest': '#e3fcec',
    //
    // 'teal-darkest': '#0d3331',
    // 'teal-darker': '#20504f',
    // 'teal-dark': '#38a89d',
    // 'teal': '#4dc0b5',
    // 'teal-light': '#64d5ca',
    // 'teal-lighter': '#a0f0ed',
    // 'teal-lightest': '#e8fffe',
    //
    // 'blue-darkest': '#12283a',
    // 'blue-darker': '#1c3d5a',
    // 'blue-dark': '#2779bd',
    // 'blue': '#3490dc',
    // 'blue-light': '#6cb2eb',
    // 'blue-lighter': '#bcdefa',
    // 'blue-lightest': '#eff8ff'
    //
    // 'indigo-darkest': '#191e38',
    // 'indigo-darker': '#2f365f',
    // 'indigo-dark': '#5661b3',
    // 'indigo': '#6574cd',
    // 'indigo-light': '#7886d7',
    // 'indigo-lighter': '#b2b7ff',
    // 'indigo-lightest': '#e6e8ff',
    //
    // 'purple-darkest': '#21183c',
    // 'purple-darker': '#382b5f',
    // 'purple-dark': '#794acf',
    // 'purple': '#9561e2',
    // 'purple-light': '#a779e9',
    // 'purple-lighter': '#d6bbfc',
    // 'purple-lightest': '#f3ebff',
    //
    // 'pink-darkest': '#451225',
    // 'pink-darker': '#6f213f',
    // 'pink-dark': '#eb5286',
    // 'pink': '#f66d9b',
    // 'pink-light': '#fa7ea8',
    // 'pink-lighter': '#ffbbca',
    // 'pink-lightest': '#ffebef',
};

module.exports = {
    purge: false,

    /*
    |-----------------------------------------------------------------------------
    | Colors                                  https://tailwindcss.com/docs/colors
    |-----------------------------------------------------------------------------
    |
    | The color palette defined above is also assigned to the "colors" key of
    | your Tailwind config. This makes it easy to access them in your CSS
    | using Tailwind's config helper. For example:
    |
    | .error { color: config('colors.red') }
    |
    */

    colors: colors,

    /*
    |-----------------------------------------------------------------------------
    | Screens                      https://tailwindcss.com/docs/responsive-design
    |-----------------------------------------------------------------------------
    |
    | Screens in Tailwind are translated to CSS media queries. They define the
    | responsive breakpoints for your project. By default Tailwind takes a
    | "mobile first" approach, where each screen size represents a minimum
    | viewport width. Feel free to have as few or as many screens as you
    | want, naming them in whatever way you'd prefer for your project.
    |
    | Tailwind also allows for more complex screen definitions, which can be
    | useful in certain situations. Be sure to see the full responsive
    | documentation for a complete list of options.
    |
    | Class name: .{screen}:{utility}
    |
    */

    screens: {
        'sm': '22.5em', // 360px
        'md': '47em', // 752px
        'lg': '64.0625em', // 1024px
        'xl': '80em',  // default breakpoint 1280px
        'print': {'raw': 'print'}

        // tailwind original
        // 'sm': '576px',
        // 'md': '768px',
        // 'lg': '992px',
        // 'xl': '1200px'
    },

    /*
    |-----------------------------------------------------------------------------
    | Fonts                                    https://tailwindcss.com/docs/fonts
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your project's font stack, or font families.
    | Keep in mind that Tailwind doesn't actually load any fonts for you.
    | If you're using custom fonts you'll need to import them prior to
    | defining them here.
    |
    | By default we provide a native font stack that works remarkably well on
    | any device or OS you're using, since it just uses the default fonts
    | provided by the platform.
    |
    | Class name: .font-{name}
    |
    */

    fonts: {
        'sans': ['-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            'sans-serif'],
        'serif': ['Georgia',
            'Constantia',
            'Lucida Bright',
            'Lucidabright',
            'Lucida Serif',
            'Lucida',
            'DejaVu Serif',
            'Bitstream Vera Serif',
            'Liberation Serif',
            'serif'],
        'mono': ['Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace']
    },

    /*
    |-----------------------------------------------------------------------------
    | Text sizes                         https://tailwindcss.com/docs/text-sizing
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your text sizes. Name these in whatever way
    | makes the most sense to you. We use size names by default, but
    | you're welcome to use a numeric scale or even something else
    | entirely.
    |
    | By default Tailwind uses the "rem" unit type for most measurements.
    | This allows you to set a root font size which all other sizes are
    | then based on. That said, you are free to use whatever units you
    | prefer, be it rems, ems, pixels or other.
    |
    | Class name: .text-{size}
    |
    */

    textSizes: {

        'xs': '.75rem',     // 12px
        'sm': '.875rem',    // 14px
        'base': '1rem',     // 16px
        'lg': '1.25rem',    // 20px
        'xl': '1.5rem',     // 24px
        '2xl': '2rem',      // 32px
        '3xl': '3rem',      // 48px
        '4xl': '4rem',      // 64px
        '5xl': '5rem',      // 80px
        '6xl': '6rem'       // 96px

        // tailwind original
        // 'xs': '.75rem',     // 12px
        // 'sm': '.875rem',    // 14px
        // 'base': '1rem',     // 16px
        // 'lg': '1.125rem',   // 18px
        // 'xl': '1.25rem',    // 20px
        // '2xl': '1.5rem',    // 24px
        // '3xl': '1.875rem',  // 30px
        // '4xl': '2.25rem',   // 36px
        // '5xl': '3rem'      // 48px
    },

    /*
    |-----------------------------------------------------------------------------
    | Font weights                       https://tailwindcss.com/docs/font-weight
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your font weights. We've provided a list of
    | common font weight names with their respective numeric scale values
    | to get you started. It's unlikely that your project will require
    | all of these, so we recommend removing those you don't need.
    |
    | Class name: .font-{weight}
    |
    */

    fontWeights: {
        'hairline': 100,
        'thin': 200,
        'light': 300,
        'normal': 400,
        'medium': 500,
        'semibold': 600,
        'bold': 700,
        'extrabold': 800,
        'black': 900
    },

    /*
    |-----------------------------------------------------------------------------
    | Leading (line height)              https://tailwindcss.com/docs/line-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your line height values, or as we call
    | them in Tailwind, leadings.
    |
    | Class name: .leading-{size}
    |
    */

    leading: {
        'collapse': 0,
        'none': 1,
        'snug': 1.125,
        'tight': 1.25,
        'normal': 1.5,
        'loose': 2
    },

    /*
    |-----------------------------------------------------------------------------
    | Tracking (letter spacing)       https://tailwindcss.com/docs/letter-spacing
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your letter spacing values, or as we call
    | them in Tailwind, tracking.
    |
    | Class name: .tracking-{size}
    |
    */

    tracking: {
        'tight': '-0.05em',
        'normal': '0',
        'wide': '0.05em'
    },

    /*
    |-----------------------------------------------------------------------------
    | Text colors                         https://tailwindcss.com/docs/text-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your text colors. By default these use the
    | color palette we defined above, however you're welcome to set these
    | independently if that makes sense for your project.
    |
    | Class name: .text-{color}
    |
    */

    textColors: colors,

    /*
    |-----------------------------------------------------------------------------
    | Background colors             https://tailwindcss.com/docs/background-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your background colors. By default these use
    | the color palette we defined above, however you're welcome to set
    | these independently if that makes sense for your project.
    |
    | Class name: .bg-{color}
    |
    */

    backgroundColors: colors,

    /*
    |-----------------------------------------------------------------------------
    | Border widths                     https://tailwindcss.com/docs/border-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border widths. Take note that border
    | widths require a special "default" value set as well. This is the
    | width that will be used when you do not specify a border width.
    |
    | Class name: .border{-side?}{-width?}
    |
    */

    borderWidths: {
        default: '1px',
        '0': '0',
        '2': '2px',
        '4': '4px',
        '8': '8px'
    },

    /*
    |-----------------------------------------------------------------------------
    | Border colors                     https://tailwindcss.com/docs/border-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border colors. By default these use the
    | color palette we defined above, however you're welcome to set these
    | independently if that makes sense for your project.
    |
    | Take note that border colors require a special "default" value set
    | as well. This is the color that will be used when you do not
    | specify a border color.
    |
    | Class name: .border-{color}
    |
    */

    borderColors: assign( {default: colors['grey-light']}, colors ),

    /*
    |-----------------------------------------------------------------------------
    | Border radius                    https://tailwindcss.com/docs/border-radius
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border radius values. If a `default` radius
    | is provided, it will be made available as the non-suffixed `.rounded`
    | utility.
    |
    | If your scale includes a `0` value to reset already rounded corners, it's
    | a good idea to put it first so other values are able to override it.
    |
    | Class name: .rounded{-side?}{-size?}
    |
    */

    borderRadius: {
        'none': '0',
        'sm': '2px',
        default: '3px',
        'lg': '12px',
        'full': '9999px'

        // tailwind original
        // 'none': '0',
        // 'sm': '.125rem',
        // default: '.25rem',
        // 'lg': '.5rem',
        // 'full': '9999px'
    },

    /*
    |-----------------------------------------------------------------------------
    | Width                                    https://tailwindcss.com/docs/width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your width utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based numeric scale, a percentage
    | based fraction scale, plus some other common use-cases. You
    | can, of course, modify these values as needed.
    |
    |
    | It's also worth mentioning that Tailwind automatically escapes
    | invalid CSS class name characters, which allows you to have
    | awesome classes like .w-2/3.
    |
    | Class name: .w-{size}
    |
    */

    width: {
        'auto': 'auto',
        'px': '1px',
        '1': '0.25rem',
        '2': '0.5rem',
        '3': '0.75rem',
        '4': '1rem',
        '5': '1.25rem',
        '6': '1.5rem',
        '8': '2rem',
        '10': '2.5rem',
        '12': '3rem',
        '16': '4rem',
        '24': '6rem',
        '32': '8rem',
        '40': '10rem',
        '48': '12rem',
        '64': '16rem',
        '80': '20rem',
        '96': '24rem',
        '112': '28rem',
        '128': '32rem',
        '1/2': '50%',
        '1/3': '33.33333%',
        '2/3': '66.66667%',
        '1/4': '25%',
        '3/4': '75%',
        '1/5': '20%',
        '2/5': '40%',
        '3/5': '60%',
        '4/5': '80%',
        '1/6': '16.66667%',
        '5/6': '83.33333%',
        'full': '100%',
        'screen': '100vw'
    },

    /*
    |-----------------------------------------------------------------------------
    | Height                                  https://tailwindcss.com/docs/height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your height utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based numeric scale plus some other
    | common use-cases. You can, of course, modify these values as
    | needed.
    |
    | Class name: .h-{size}
    |
    */

    height: {
        'auto': 'auto',
        'px': '1px',
        '1': '0.25rem',
        '2': '0.5rem',
        '3': '0.75rem',
        '4': '1rem',
        '5': '1.25rem',
        '6': '1.5rem',
        '8': '2rem',
        '10': '2.5rem',
        '12': '3rem',
        '16': '4rem',
        '24': '6rem',
        '32': '8rem',
        '40': '10rem',
        '48': '12rem',
        '64': '16rem',
        '80': '20rem',
        '96': '24rem',
        '112': '28rem',
        '128': '32rem',
        'full': '100%',
        'screen': '100vh'
    },

    /*
    |-----------------------------------------------------------------------------
    | Minimum width                        https://tailwindcss.com/docs/min-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your minimum width utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | couple common use-cases by default. You can, of course, modify
    | these values as needed.
    |
    | Class name: .min-w-{size}
    |
    */

    minWidth: {
        '0': '0',
        'xs': '20rem',
        'sm': '24rem',
        'md': '28rem',
        'lg': '32rem',
        'xl': '36rem',
        'full': '100%'
    },

    /*
    |-----------------------------------------------------------------------------
    | Minimum height                      https://tailwindcss.com/docs/min-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your minimum height utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | few common use-cases by default. You can, of course, modify these
    | values as needed.
    |
    | Class name: .min-h-{size}
    |
    */

    minHeight: {
        '0': '0',
        'full': '100%',
        'screen': '100vh'
    },

    /*
    |-----------------------------------------------------------------------------
    | Maximum width                        https://tailwindcss.com/docs/max-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your maximum width utility sizes. These can
    | be percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based scale and a "full width" size,
    | which is basically a reset utility. You can, of course,
    | modify these values as needed.
    |
    | Class name: .max-w-{size}
    |
    */

    maxWidth: {
        'xs': '20rem',
        'sm': '30rem',
        'md': '40rem',
        'lg': '50rem',
        'xl': '60rem',
        '2xl': '70rem',
        '3xl': '80rem',
        '4xl': '90rem',
        '5xl': '100rem',
        'full': '100%'
    },

    /*
    |-----------------------------------------------------------------------------
    | Maximum height                      https://tailwindcss.com/docs/max-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your maximum height utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | couple common use-cases by default. You can, of course, modify
    | these values as needed.
    |
    | Class name: .max-h-{size}
    |
    */

    maxHeight: {
        'full': '100%',
        'xs': '12rem',
        'sm': '16rem',
        'md': '32rem',
        'lg': '64rem',
        'screen': '100vh'
    },

    /*
    |-----------------------------------------------------------------------------
    | Padding                                https://tailwindcss.com/docs/padding
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your padding utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default we
    | provide a sensible rem based numeric scale plus a couple other
    | common use-cases like "1px". You can, of course, modify these
    | values as needed.
    |
    | Class name: .p{side?}-{size}
    |
    */

    padding: {
        'full': '100%',
        'auto': 'auto',
        'px': '1px',
        '0': '0',
        '1': '0.25rem',
        '2': '0.5rem',
        '3': '0.75rem',
        '4': '1rem',
        '6': '1.5rem',
        '8': '2rem',
        '10': '2.5rem',
        '12': '3rem',
        '14': '3.5rem',
        '16': '4rem',
        '20': '5rem'

        // tailwind original
        // 'px': '1px',
        // '0': '0',
        // '1': '0.25rem',
        // '2': '0.5rem',
        // '3': '0.75rem',
        // '4': '1rem',
        // '6': '1.5rem',
        // '8': '2rem'
    },

    /*
    |-----------------------------------------------------------------------------
    | Margin                                  https://tailwindcss.com/docs/margin
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your margin utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default we
    | provide a sensible rem based numeric scale plus a couple other
    | common use-cases like "1px". You can, of course, modify these
    | values as needed.
    |
    | Class name: .m{side?}-{size}
    |
    */

    margin: {
        // deprecated
        // '3': '1rem',
        // '4': '2rem',
        // '5': '4rem',
        // '6': '8rem',
        // '7': '16rem',

        'auto': 'auto',
        'px': '1px',
        '0': '0',
        '1': '0.25rem',
        '2': '0.5rem',
        '3': '0.75rem',
        '4': '1rem',
        '6': '1.5rem',
        '8': '2rem',
        '10': '2.5rem',
        '12': '3rem',
        '16': '4rem',
        '20': '5rem',
        '24': '6rem'

        // tailwind original
        // 'auto': 'auto',
        // 'px': '1px',
        // '0': '0',
        // '1': '0.25rem',
        // '2': '0.5rem',
        // '3': '0.75rem',
        // '4': '1rem',
        // '6': '1.5rem',
        // '8': '2rem'
    },

    /*
    |-----------------------------------------------------------------------------
    | Negative margin                https://tailwindcss.com/docs/negative-margin
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your negative margin utility sizes. These can
    | be percentage based, pixels, rems, or any other units. By default we
    | provide matching values to the padding scale since these utilities
    | generally get used together. You can, of course, modify these
    | values as needed.
    |
    | Class name: .-m{side?}-{size}
    |
    */

    negativeMargin: {
        'px': '1px',
        '0': '0',
        '1': '0.25rem',
        '2': '0.5rem',
        '3': '0.75rem',
        '4': '1rem',
        '6': '1.5rem',
        '8': '2rem'

        // tailwind original
        // 'px': '1px',
        // '0': '0',
        // '1': '0.25rem',
        // '2': '0.5rem',
        // '3': '0.75rem',
        // '4': '1rem',
        // '6': '1.5rem',
        // '8': '2rem'
    },

    /*
    |-----------------------------------------------------------------------------
    | Shadows                                https://tailwindcss.com/docs/shadows
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your shadow utilities. As you can see from
    | the defaults we provide, it's possible to apply multiple shadows
    | per utility using comma separation.
    |
    | If a `default` shadow is provided, it will be made available as the non-
    | suffixed `.shadow` utility.
    |
    | Class name: .shadow-{size?}
    |
    */

    shadows: {
        default: '0 2px 4px 0 rgba(0,0,0,0.10)',
        'md': '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
        'lg': '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
        'diffuse': '0 0 40px rgb(0 0 0 / 10%), 0 0 0px 1px rgba(0,0,0, 4%)',
        'inner': 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
        'none': 'none'
    },

    /*
    |-----------------------------------------------------------------------------
    | Z-index                                https://tailwindcss.com/docs/z-index
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your z-index utility values. By default we
    | provide a sensible numeric scale. You can, of course, modify these
    | values as needed.
    |
    | Class name: .z-{index}
    |
    */

    zIndex: {
        'auto': 'auto',
        '0': 0,
        '1': 1,
        '10': 10,
        '20': 20,
        '30': 30,
        '40': 40,
        '50': 50,
        '60': 60,
        '70': 70,
        '80': 80,
        '90': 90,
        '100': 100,
        'top': 101
    },

    /*
    |-----------------------------------------------------------------------------
    | Opacity                                https://tailwindcss.com/docs/opacity
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your opacity utility values. By default we
    | provide a sensible numeric scale. You can, of course, modify these
    | values as needed.
    |
    | Class name: .opacity-{name}
    |
    */

    opacity: {
        '0': '0',
        '10': '.1',
        '20': '.2',
        '30': '.3',
        '50': '.5',
        '75': '.75',
        '80': '.8',
        '90': '.9',
        '100': '1'
    },

    /*
    |-----------------------------------------------------------------------------
    | SVG fill                                   https://tailwindcss.com/docs/svg
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your SVG fill colors. By default we just provide
    | `fill-current` which sets the fill to the current text color. This lets you
    | specify a fill color using existing text color utilities and helps keep the
    | generated CSS file size down.
    |
    | Class name: .fill-{name}
    |
    */

    svgFill: {
        'current': 'currentColor'
    },

    /*
    |-----------------------------------------------------------------------------
    | SVG stroke                                 https://tailwindcss.com/docs/svg
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your SVG stroke colors. By default we just provide
    | `stroke-current` which sets the stroke to the current text color. This lets
    | you specify a stroke color using existing text color utilities and helps
    | keep the generated CSS file size down.
    |
    | Class name: .stroke-{name}
    |
    */

    svgStroke: {
        'current': 'currentColor'
    },

    /*
    |-----------------------------------------------------------------------------
    | Modules                  https://tailwindcss.com/docs/configuration#modules
    |-----------------------------------------------------------------------------
    |
    | Here is where you control which modules are generated and what variants are
    | generated for each of those modules.
    |
    | Currently supported variants: 'responsive', 'hover', 'focus'
    |
    | To disable a module completely, use `false` instead of an array.
    |
    */

    modules: {
        appearance: ['responsive'],
        backgroundAttachment: ['responsive'],
        backgroundColors: ['responsive', 'hover', 'group-hover'],
        backgroundPosition: ['responsive'],
        backgroundRepeat: ['responsive'],
        backgroundSize: ['responsive'],
        borderColors: ['responsive', 'hover'],
        borderRadius: ['responsive'],
        borderStyle: ['responsive', 'focus'],
        borderWidths: ['responsive'],
        cursor: ['responsive'],
        display: ['responsive', 'hover', 'group-hover'],
        flexbox: ['responsive'],
        float: ['responsive'],
        fonts: ['responsive'],
        fontWeights: ['responsive', 'hover'],
        height: ['responsive'],
        leading: ['responsive'],
        lists: ['responsive'],
        margin: ['responsive'],
        maxHeight: ['responsive'],
        maxWidth: ['responsive'],
        minHeight: ['responsive'],
        minWidth: ['responsive'],
        negativeMargin: ['responsive'],
        opacity: ['hover', 'group-hover'],
        overflow: ['responsive'],
        padding: ['responsive'],
        pointerEvents: ['responsive'],
        position: ['responsive'],
        resize: ['responsive'],
        shadows: ['responsive'],
        svgFill: [],
        svgStroke: [],
        textAlign: ['responsive'],
        textColors: ['responsive', 'hover', 'group-hover'], // todo: + group-hover variants
        textSizes: ['responsive'],
        textStyle: ['responsive', 'hover'],
        tracking: ['responsive'],
        userSelect: ['responsive'],
        verticalAlign: ['responsive'],
        visibility: ['responsive'],
        whitespace: ['responsive'],
        width: ['responsive'],
        zIndex: ['responsive', 'hover']
    },

    /*
    |-----------------------------------------------------------------------------
    | Plugins                                https://tailwindcss.com/docs/plugins
    |-----------------------------------------------------------------------------
    |
    | Here is where you can register any plugins you'd like to use in your
    | project. Tailwind's built-in `container` plugin is enabled by default to
    | give you a Bootstrap-style responsive container component out of the box.
    |
    | Be sure to view the complete plugin documentation to learn more about how
    | the plugin system works.
    |
    */

    plugins: [// require( 'tailwindcss/plugins/container' )( {
        //     center: true,
        // } )
    ],

    /*
    |-----------------------------------------------------------------------------
    | Advanced Options         https://tailwindcss.com/docs/configuration#options
    |-----------------------------------------------------------------------------
    |
    | Here is where you can tweak advanced configuration options. We recommend
    | leaving these options alone unless you absolutely need to change them.
    |
    */

    options: {
        prefix: '',
        important: false,
        separator: ':'
    }

};

module.exports.theme = {
    screens: module.exports.screens,
    colors: module.exports.colors,
    fontFamily: module.exports.fonts,
    fontSize: module.exports.textSizes,
    fontWeight: module.exports.fontWeights,
    lineHeight: module.exports.leading,
    letterSpacing: module.exports.tracking,
    borderColor: withDefaultAlias( module.exports.borderColors ),
    borderRadius: withDefaultAlias( module.exports.borderRadius ),
    borderWidth: withDefaultAlias( module.exports.borderWidths ),
    boxShadow: withDefaultAlias( module.exports.shadows ),
    fill: module.exports.svgFill,
    height: module.exports.height,
    maxHeight: module.exports.maxHeight,
    maxWidth: module.exports.maxWidth,
    minHeight: module.exports.minHeight,
    minWidth: module.exports.minWidth,
    opacity: module.exports.opacity,
    padding: module.exports.padding,
    spacing: module.exports.margin,
    stroke: module.exports.svgStroke,
    width: module.exports.width,
    zIndex: module.exports.zIndex
};
